import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController } from 'ionic-angular';
import { Observable } from 'rxjs';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import * as _ from 'lodash';
import { ClinicMedicationsAddPage } from '../clinic-medications-add/clinic-medications-add';

@IonicPage()
@Component({
  selector: 'page-clinic-medications',
  templateUrl: 'clinic-medications.html',
})
export class ClinicMedicationsPage {
  public medicationsList: Observable<any[]>;
  public allMedsList: Observable<any[]>;
  clinic_name: string = null;
  clinic_id: string = null;
  allMedList: any[];
  medsList: any[];

  constructor(
    public navCtrl: NavController, 
    public alertCtrl: AlertController,
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private database: DatabaseProvider,
    public modalCtrl: ModalController,
    ) {
    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.database
      .getMedicationsByClinic(this.clinic_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        })
      })
      .subscribe((meds) => {
        this.medsList = meds;
      });

      this.database
      .getMedications()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .subscribe((meds) => {
        this.allMedList = meds;
      });
    });
  }

  addAll()  {
    // this.allMedsList.subscribe((json) => {
      _(this.allMedList).forEach((item) => {
        let drug = _.omit(item, ['id']);
        this.addMed(drug);
      });
    // })
  }

  addPrescription() {
   // this.allMedsList.subscribe((json) => {
      _(this.allMedList).forEach((item) => {
        let drug = _.omit(item, ['id']);
        if(drug.type === 'Prescription')  {
          this.addMed(drug);
        }
      });
   // })
  }

  addOTC()  {
    // this.allMedsList.subscribe((json) => {
      _(this.allMedList).forEach((item) => {
        let drug = _.omit(item, ['id']);
        if(drug.type === 'Over The Counter')  {
          this.addMed(drug);
        }
      });
   //  })
  }

  async addMed(medication) {
    // let parseJSON = JSON.parse(this.medications)
    // console.log("Loaded meds: ", parseJSON);

    // _(parseJSON).forEach((item) => {
    //   let drug = _.omit(item, ['id']);
    //   console.log(drug);
    return new Promise((resolve, reject) => {
       this.database.addMedicationByClinic(this.clinic_id, medication).then(_ => {
          console.log("Clinic Med added: ", medication);
          resolve(true);
        })
        .catch((err) => {
          console.log("Error adding medication: ", medication);
          reject(false);
        })
      });
    // });
  }

  deleteAll() {
    let confirm = this.alertCtrl.create({
      title: "Delete All Medications! ",
      message:
        "This will remove all medications currently assigned to this clinic.  Are you sure you want to do this?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
              _(this.medsList).forEach((item) => {
                let drug = _.omit(item, ['id']);
                  this.database.deleteMedicationFromClinic(this.clinic_id, drug.din).then(() => {
                    console.log('Successfully deleted the medication');
                  })
                  .catch((error) => {
                    console.log('Error deleting the medication');
                  });
              });
          }
        }
      ]
    });
    confirm.present();
  }

  deleteMedicationFromClinic(medication)  {
    let confirm = this.alertCtrl.create({
      title: "Delete Medication",
      message:
        "Are you sure you would like to remove this medication from the clinic?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            this.database.deleteMedicationFromClinic(this.clinic_id, medication.din).then(() => {
              console.log('Successfully deleted the medication from this clinic');
            })
            .catch((error) => {
              console.log('Error deleting medication');
            });
            console.log(medication);
          }
        }
      ]
    });
    confirm.present();
  }

  selectMedications() {
    let options = {
      title: "Add Medications",
      inputs: [],
      buttons: [
        {
          text: "Update",
          role: "submit",
          handler: data => {
            console.log(data)
            _.forEach(data, (med) => {
              this.addMed(med);
            });
          }
        },
        {
          text: "Cancel",
          role: "cancel",
          handler: data => console.log("Cancel clicked")
        }
      ]
    };

    _.forEach(this.allMedList, (item) => {
      options.inputs.push(
        {
          type: 'checkbox',
          label: item.name + ' - ' + item.din,
          value: item
        }
      )
    });
    let alert = this.alertCtrl.create(options);
    alert.present();

  }

  addClinicOnly() {
    let clinicModal = this.modalCtrl.create(ClinicMedicationsAddPage, null, {showBackdrop: true, enableBackdropDismiss: false});
    clinicModal.present();
  }

  editMedicationFromClinic(medication)  {
    let clinicModal = this.modalCtrl.create(ClinicMedicationsAddPage, {'meddata': medication} , {showBackdrop: true, enableBackdropDismiss: false});
    clinicModal.present();
  }

  reorderItems(indexes)  {
    let element = this.medsList[indexes.from];

  // Reorder the array:

  this.medsList.splice(indexes.from, 1);
  this.medsList.splice(indexes.to, 0, element);

  // Build the multi-location update:

  let min = Math.min(indexes.from, indexes.to);
  let max = Math.max(indexes.from, indexes.to);

  let reindexed = {};
  _.forEach(this.medsList, async (med, index) => {
    med['sort'] = index;
    await this.database.updateMedicationByClinic(this.clinic_id, med);
  })

  // Update the reordered elements:
  // console.log(this.medsList);
  }
}



// WEBPACK FOOTER //
// ./src/pages/clinic-medications/clinic-medications.ts